import React from 'react'
import { MemberSummary } from '@Entities/member/member-summary'
import { RightsHolderModel } from '@Entities/rightsholder'
import AccountCard from '@Components/Cards/AccountCard'
import Navigation from '@App/navigation'
import { RIGHTSHOLDER_VALIDATION_STATUSES } from '@Const/rightsholder-statuses'
import { ICONS } from '@Const/common'

interface RightsholderAccountCardProps {
    rightsholderData: MemberSummary | RightsHolderModel
    openPopup?(): void
    viewDetails?: boolean
}

export const RightsholderAccountCard = (props: RightsholderAccountCardProps) => {
    const { rightsholderData, openPopup, viewDetails = true } = props
    const idForLink = 'id' in rightsholderData ? rightsholderData.id : rightsholderData.ipId
    const isValidationStatusWrong =
        !rightsholderData.validationStatus ||
        rightsholderData.validationStatus === RIGHTSHOLDER_VALIDATION_STATUSES.HFA_COPIED.name
    return (
        <AccountCard
            name={rightsholderData.name}
            totalWorks={rightsholderData.totalWorks}
            isValidationStatusWrong={isValidationStatusWrong}
            teamMembers={rightsholderData.teamMembers}
            validationStatus={rightsholderData.validationStatus}
            updateDate={'updateDate' in rightsholderData ? rightsholderData.updateDate : undefined}
            openPopup={openPopup}
            viewDetails={viewDetails}
            link={Navigation.rightholder.summary(idForLink)}
            icon={ICONS.account}
            blueImageFilter
            countType="works"
        />
    )
}

export default RightsholderAccountCard
